import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  id: null,
  affiliateId: null,
  subs: '',
  email: '',
  customerId: '',
  contactForm: {
    message: '',
    messageSent: false,
    messageVariant: ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
